/* eslint-disable react/prop-types */
/* eslint-disable max-statements */
/* eslint-disable complexity */
import React, {useCallback, useEffect, useMemo} from  "react";
import PropTypes from "prop-types";
import loadable from "@loadable/component";
import styles from "./styles.css";
import MakeModelFilter from "./make-model/component";
import GreatDeals from "./great-deals/component";
import OnSale from "./on-sale/component";
import Loader from "../../shared/loader";
const BodyTypeFilter = loadable(() => import("./body-type-filter/component"), {fallback: <Loader />});
const YearRangeFilter = loadable(() => import("./year-filter/component"), {fallback: <Loader />});
const KilometerFilter = loadable(() => import("./km-filter/component"), {fallback: <Loader />});
const PriceAndFinanceFilter = loadable(() => import("./price-finance/component"), {fallback: <Loader />});
const TransmissionFilter = loadable(() => import("./transmmission-filter/component"), {fallback: <Loader />});
const FuelTypeFilter = loadable(() => import("./fuel-type-filter/component"), {fallback: <Loader />});
const Features = loadable(() => import("./features/component"), {fallback: <Loader />});
const Drivetrain = loadable(() => import("./drivetrain/component"), {fallback: <Loader />});
const SeatFilter = loadable(() => import("./seat-filter/component"), {fallback: <Loader />});
const Colour = loadable(() => import("./colour/component"), {fallback: <Loader />});
const ImperfectionAndSafety = loadable(() => import("./imperfection-and-safety/component"), {fallback: <Loader />});
const DeliveryTime = loadable(() => import("./delivery-time/component"), {fallback: <Loader />});
const TestDrive = loadable(() => import("./test-drive/component"), {fallback: <Loader />});
const CitiesFilter = loadable(() => import("./cities-filter/component"), {fallback: <Loader />});

import { FILTER_ENTITIES } from "../../../utils/filters-v2/constants";
import parseLocationSearchParams from "../../../utils/helpers/parse-location-search-params";
import { useHistory } from "react-router";
import Filters from "../../../utils/filters-v2";
import { getCity } from "../../../utils/helpers/get-city-from-listing";
import { trackDesktopCustomEventsAU } from "../../../tracking";
import { AU_DESKTOP_EVENTS } from "../../../tracking/au.desktop-events";
import { updateSavedFilters } from "../../../utils/helpers/update-saved-filters";
import Accordion from "../../shared/accordion";
import TradeInYourCarToggleButton from "../trade-in-your-car-toggle-button";
import { makePriceLabelRound } from "../../../utils/helpers/make-price-label";
import getUpdatedAppliedFilters from "../../../utils/filters-v2/get-updated-applied-filters";
import useModifiedFilters from "../../../hooks/use-modified-filters";
import NewIcon from "./images/new.svg";
import { GA_EVENTS } from "../car-listing/tracking";
import { AU_FILTER_EVENT, AU_FILTER_EVENTS_KEYS } from "../../../tracking/au.mobile-filter-events";
import AccordionItem from "./accordion-item";

const FILTER_COMPONENT = {
    [FILTER_ENTITIES.ALLMAKES]: {
        header: "Make/Model",
        Component: MakeModelFilter,
        type: FILTER_ENTITIES.ALLMAKES
    },
    [FILTER_ENTITIES.GREAT_DEALS]: {
        header: "Great Deals",
        Component: GreatDeals,
        type: FILTER_ENTITIES.GREAT_DEALS,
        icon: NewIcon
    },
    [FILTER_ENTITIES.PRICE]: {
        header: "Price/Finance",
        Component: PriceAndFinanceFilter,
        type: FILTER_ENTITIES.PRICE
    },
    [FILTER_ENTITIES.CITYNAME]: {
        header: "Locations",
        Component: CitiesFilter,
        type: FILTER_ENTITIES.CITYNAME
    },
    [FILTER_ENTITIES.BODY_TYPE]: {
        header: "Body Type",
        Component: BodyTypeFilter,
        type: FILTER_ENTITIES.BODY_TYPE
    },
    [FILTER_ENTITIES.YEAR]: {
        header: "Year",
        Component: YearRangeFilter,
        type: FILTER_ENTITIES.YEAR
    },
    [FILTER_ENTITIES.ODOMETER_READING]: {
        header: "KMs Driven",
        Component: KilometerFilter,
        type: FILTER_ENTITIES.ODOMETER_READING
    },

    [FILTER_ENTITIES.TRANSMISSION]: {
        header: "Transmission",
        Component: TransmissionFilter,
        type: FILTER_ENTITIES.TRANSMISSION

    },
    [FILTER_ENTITIES.FUEL_TYPE]: {
        header: "Fuel Type",
        Component: FuelTypeFilter,
        type: FILTER_ENTITIES.FUEL_TYPE

    },
    [FILTER_ENTITIES.FEATURES]: {
        header: "Features",
        Component: Features,
        type: FILTER_ENTITIES.FEATURES

    },
    [FILTER_ENTITIES.DRIVETYPE]: {
        header: "Drivetrain",
        Component: Drivetrain,
        type: FILTER_ENTITIES.DRIVETYPE

    },
    [FILTER_ENTITIES.SEATS]: {
        header: "Seats",
        Component: SeatFilter,
        type: FILTER_ENTITIES.SEATS

    },
    [FILTER_ENTITIES.COLOR]: {
        header: "Colour",
        Component: Colour,
        type: FILTER_ENTITIES.COLOR

    },
    [FILTER_ENTITIES.IMPERFECTIONS]: {
        header: "Imperfections and Safety",
        Component: ImperfectionAndSafety,
        type: FILTER_ENTITIES.IMPERFECTIONS

    },
    [FILTER_ENTITIES.DELIVERY_TIME]: {
        header: "Delivery Time",
        Component: DeliveryTime,
        type: FILTER_ENTITIES.DELIVERY_TIME
    }
};

let FILTER_COMPONENT_LIST = {...FILTER_COMPONENT};

const FILTER_EVENT_NAMES = {
    [FILTER_ENTITIES.PRICE]: {
        onSelectEvent: AU_DESKTOP_EVENTS.FILTER_REVAMP_FILTER_PRICE_SELECTED
    },
    [FILTER_ENTITIES.YEAR]: {
        onSelectEvent: AU_DESKTOP_EVENTS.FILTER_REVAMP_FILTER_YEAR_SELECTED
    },
    [FILTER_ENTITIES.ODOMETER_READING]: {
        onSelectEvent: AU_DESKTOP_EVENTS.FILTER_REVAMP_FILTER_KM_SELECTED
    }
};

const getComponentProps = (allFilters, type) => {
    const props = {
        [type]: allFilters[type],
        ...(type === FILTER_ENTITIES.ALLMAKES && {
            [FILTER_ENTITIES.POPULARMAKES]: allFilters[FILTER_ENTITIES.POPULARMAKES]
        })
    };
    return props;
};

const FilerRevamp = (props) => {

    const {
        allFilters = {},
        selectedFilters,
        selectedCityName,
        updateFilterOptionDataConnect,
        updateAppliedFiltersConnect,
        updateAppliedSuggestionsConnect,
        reloadCarListConnect,
        urlOptions,
        config,
        setMarketingCategoryConnect,
        metaContent,
        tradeInToggleSelected,
        userTradeInData,
        replaceSelectedFilterConnect,
        isViewCarsButtonTriggered,
        getTradeInToggleVisibleConnect,
        setViewCarsButtonTriggeredConnect,
        isLoggedIn,
        saleConfig = {}
    } = props;

    /// filter revamp logic open
    const history = useHistory();
    const {location} = history;
    const queryParams = parseLocationSearchParams(location.search);
    const searchQuery = queryParams.search;
    const { tradeInAmount } =  userTradeInData || {};
    const showTestDriveFilter = allFilters[FILTER_ENTITIES.TESTDRIVE] && allFilters[FILTER_ENTITIES.TESTDRIVE].options && allFilters[FILTER_ENTITIES.TESTDRIVE].options.length;
    const {saleLive = false} = saleConfig?.data || {};
    const cityFilters = allFilters[FILTER_ENTITIES.CITYNAME] || {};
    const { mainFilter: showCityFilterSection = false } = cityFilters || {};

    const {validFilters, getModifiedFilters, isSeoFilterPresent} = useModifiedFilters(showCityFilterSection);
    useEffect(() => {
        if (validFilters?.length && validFilters.indexOf(FILTER_ENTITIES.CITYNAME) > -1) {
            delete FILTER_COMPONENT_LIST[FILTER_ENTITIES.CITYNAME];
        } else FILTER_COMPONENT_LIST = {...FILTER_COMPONENT};
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [validFilters]);

    useEffect(() => {
        window.scrollTo({ top: 0, left: 0});
    }, [location.search]);

    useEffect(() => {
        if (!isViewCarsButtonTriggered && isLoggedIn) {
            getTradeInToggleVisibleConnect();
        } else {
            setViewCarsButtonTriggeredConnect(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoggedIn, isViewCarsButtonTriggered]);

    const triggerGAEvent = (eventAction) => {
        const data = selectedFilters.map(item => {
            const filterKeyName = item.filterKey !== FILTER_ENTITIES.PRICE ? allFilters[item.filterKey].displayText : "PRICE/FINANCE";
            if (item.isRangeFilter) {
                return `${filterKeyName}:${item.min},${item.max}`;
            } else {
                return `${filterKeyName}:${item.optionKey}${item.subOptionKey ? `:${item.subOptionKey}` : ""}`;
            }
        }).join(", ");
        trackDesktopCustomEventsAU(eventAction, {
            ...AU_FILTER_EVENT[eventAction],
            eventLabel: data});
    };

    const getListingUrl = (customSelectedFilters) => {

        const isSeoMakeMdelCityFilter = isSeoFilterPresent(customSelectedFilters);
        const modifiedFilter = getModifiedFilters(customSelectedFilters);

        if (isSeoMakeMdelCityFilter) {
            replaceSelectedFilterConnect(modifiedFilter);
        }

        const filters = new Filters({ cityCode: getCity(metaContent).code, cityName: selectedCityName });
        const {relativeURL} = filters.getListingPayload({
            selectedFilters: modifiedFilter,
            filters: allFilters, options: {
                ...urlOptions,
                ...(
                    searchQuery && {
                        search: searchQuery
                    }
                )
            }
        });

        history.replace(relativeURL);
        window.setTimeout(() => window.scrollTo(0, 0));
    };

    const onClickShowCars = (customSelectedFilters) => {
        triggerGAEvent(AU_FILTER_EVENTS_KEYS.FILTER_REVAMP_FILTER_SHOW_CARS);

        updateSavedFilters(selectedFilters);
        updateAppliedFiltersConnect();
        updateAppliedSuggestionsConnect();
        setMarketingCategoryConnect(true);
        reloadCarListConnect(true);

        getListingUrl(customSelectedFilters);
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth"
        });
    };

    // eslint-disable-next-line max-statements
    const onOptionSelection = (data) => {
        let optionValue = data.optionKey;
        let updatedFilter = selectedFilters;
        const { filterKey} = data;

        if (data.isRangeFilter) {
            const { min = "", max = ""} = data.rangeValues || {};
            optionValue = `${min}-${max}`;
            const {onSelectEvent: gaEventName = ""} = FILTER_EVENT_NAMES[filterKey] || {};
            trackDesktopCustomEventsAU(gaEventName, {eventLabel: `${optionValue}`});
        }

        if (filterKey === "make" && data.subOptionKey) {
            const makeData =  selectedFilters.find(item => (item.optionKey || "").toLowerCase() === optionValue.toLowerCase() && !item.subOptionKey);
            if (makeData) {
                updateFilterOptionDataConnect({...makeData, isSelected: false});
            }
        }
        if (filterKey === "make" && !data.subOptionKey) {
            updatedFilter =  selectedFilters.filter(item => (item.optionKey || "").toLowerCase() !== optionValue.toLowerCase());
        }
        if (data) {
            updateFilterOptionDataConnect(data);
        }

        const updateFiter = getUpdatedAppliedFilters(data, updatedFilter);
        if (filterKey === "make" && !data.subOptionKey) {
            replaceSelectedFilterConnect(updateFiter);
        }
        onClickShowCars(updateFiter);
    };

    /// filter revamp logic closed

    const getFilterLabelCount = (filter) => {
        let filteredArray = [];
        filteredArray = selectedFilters.filter((filterType) => {
            if (filter === FILTER_ENTITIES.SAFETYANDQUALITY) {
                return filterType.filterKey === FILTER_ENTITIES.SAFETYANDQUALITY || filterType.filterKey === FILTER_ENTITIES.IMPERFECTIONS;
            } else {
                return filterType.filterKey === filter;
            }
        });
        return filteredArray.length > 0 ? filteredArray.length : "";
    };

    const tradeInToggleSelectedHandler = () => {
        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.TRADE_IN_TOP_FUNNEL_TRADE_IN_PRICE_TOGGLE_CLP, {eventLabel: tradeInToggleSelected ? "off" : "on"});
        reloadCarListConnect(true);
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    const getDefaultActiveIndex = useMemo(() => {
        if (Object.keys(FILTER_COMPONENT_LIST).indexOf(FILTER_ENTITIES.GREAT_DEALS) > -1) {return [0, 1];} else {return [0];}
    }, []);

    const getHeaderText = useCallback((header, type) => {
        if (type === FILTER_ENTITIES.GREAT_DEALS) {
            const headerText = header.split(" ");
            headerText[1] = headerText[1].toLowerCase();
            return headerText.join(" ");
        } else {return header;}
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const triggerEvent = (item, currentVisibleStates) => {
        if (item === FILTER_ENTITIES.CITYNAME && currentVisibleStates) {
            trackDesktopCustomEventsAU(GA_EVENTS.FILTER_LOCATION_SELECTED, {
                ...GA_EVENTS.FILTER_LOCATION_SELECTED
            });
        }
    };

    return (
        <div styleName={"styles.filterWrapper"}>
            <div styleName={"styles.filterHeader"}>
                <p styleName={"styles.filterHeading"}>FILTERS</p>
            </div>
            {saleLive && <div styleName={"styles.makeModelOuter styles.onSale"}>
                <OnSale
                    {...getComponentProps(allFilters, FILTER_ENTITIES.PROMOTION)}
                    selectedFilters={selectedFilters}
                    onOptionSelection={onOptionSelection}
                    appliedFilters={selectedFilters}
                    filter={allFilters[FILTER_ENTITIES.PROMOTION]}
                    config={config}
                    allFilters={allFilters}
                    saleLive={saleLive}
                    {...props}
                />
            </div>}
            {tradeInToggleSelected !== null && <div styleName={"styles.makeModelOuter"}>
                <div styleName={"styles.tradeInPriceWrapper"}>
                    <p styleName={"styles.tradeInPrice"}>Trade in Price</p>
                    <TradeInYourCarToggleButton onTradeInSelectCallback={tradeInToggleSelectedHandler} />
                </div>
                {tradeInToggleSelected && <div styleName={"styles.tradeInValuationWrapper"}>
                    <p styleName={"styles.tradeInValuation"}>Trade in valuation <span>-{makePriceLabelRound(tradeInAmount)}</span> applied on all cars.</p>
                </div>}
            </div>}
            {showTestDriveFilter && <div styleName={"styles.makeModelOuter styles.testDrive"}>
                <TestDrive
                    {...getComponentProps(allFilters, FILTER_ENTITIES.TESTDRIVE)}
                    selectedFilters={selectedFilters}
                    onOptionSelection={onOptionSelection}
                    appliedFilters={selectedFilters}
                    filter={allFilters[FILTER_ENTITIES.TESTDRIVE]}
                    config={config}
                    allFilters={allFilters}
                    {...props}
                />
            </div>}
            <div styleName={"styles.filterContainer"}>
                <Accordion
                    toggleAll={false}
                    collapseAccordion={true}
                    totalItems={Object.keys(FILTER_COMPONENT_LIST).length}
                    defaultActiveIndex={getDefaultActiveIndex}
                >
                    {({ onClick, currentVisibleStates, loading, loadingIndex }) => (
                        <React.Fragment>{Object.keys(FILTER_COMPONENT_LIST).map((item, index) => {
                            const { header, Component, type, icon = null } = FILTER_COMPONENT_LIST[item];
                            const filterCount = getFilterLabelCount(type === FILTER_ENTITIES.ALLMAKES ? FILTER_ENTITIES.MAKE : type);

                            if (!allFilters[item]) return null;

                            return (
                                <div styleName={"styles.makeModelOuter"} key={item}>
                                    <AccordionItem
                                        item={item}
                                        index={index}
                                        Component={Component}
                                        header={header}
                                        type={type}
                                        icon={icon}
                                        filterCount={filterCount}
                                        allFilters={allFilters}
                                        selectedFilters={selectedFilters}
                                        onOptionSelection={onOptionSelection}
                                        config={config}
                                        getListingUrl={getListingUrl}
                                        getComponentProps={getComponentProps}
                                        triggerEvent={triggerEvent}
                                        getHeaderText={getHeaderText}
                                        props={{
                                            onClick,
                                            currentVisibleStates,
                                            loading,
                                            loadingIndex,
                                            ...props
                                        }}
                                    />
                                </div>
                            );
                        })}</React.Fragment>
                    )}
                </Accordion>
                {!saleLive && <div styleName={"styles.makeModelOuter styles.onSale"}>
                    <OnSale
                        {...getComponentProps(allFilters, FILTER_ENTITIES.PROMOTION)}
                        selectedFilters={selectedFilters}
                        onOptionSelection={onOptionSelection}
                        appliedFilters={selectedFilters}
                        filter={allFilters[FILTER_ENTITIES.PROMOTION]}
                        config={config}
                        allFilters={allFilters}
                        {...props}
                    />
                </div>}
                {/* <p styleName={"styles.end"}><span>You’ve reached the end</span></p> */}
            </div>
        </div>
    );
};

FilerRevamp.propTypes = {
    allFilters: PropTypes.object,
    selectedFilters: PropTypes.array,
    listingCount: PropTypes.number,
    selectedOnScreenFilter: PropTypes.string,
    history: PropTypes.object,
    updateFilterOptionDataConnect: PropTypes.func,
    updateSelectedFilterSuggestionToDefaultConnect: PropTypes.func,
    updateSelectedOnScreenFilterConnect: PropTypes.func,
    clearAllFiltersConnect: PropTypes.func,
    fetchListingCountConnect: PropTypes.func,
    selectedCityCode: PropTypes.string,
    selectedCityName: PropTypes.string,
    selectedSuggestions: PropTypes.array,
    isListingCountLoading: PropTypes.bool,
    updateAppliedFiltersConnect: PropTypes.func,
    updateAppliedSuggestionsConnect: PropTypes.func,
    reloadCarListConnect: PropTypes.func,
    location: PropTypes.object,
    urlOptions: PropTypes.object,
    config: PropTypes.object,
    setMarketingCategoryConnect: PropTypes.func,
    metaContent: PropTypes.object,
    tradeInToggleSelected: PropTypes.bool,
    userTradeInData: PropTypes.object,
    replaceSelectedFilterConnect: PropTypes.object,
    getTradeInToggleVisibleConnect: PropTypes.func,
    isViewCarsButtonTriggered: PropTypes.bool,
    setViewCarsButtonTriggeredConnect: PropTypes.func,
    showTestDriveV2: PropTypes.object,
    isLoggedIn: PropTypes.bool,
    saleConfig: PropTypes.object
};

export default FilerRevamp;
